module.exports = __webpack_public_path__ + "img/register.d7d6c1cb.svg";